import { render, staticRenderFns } from "./TheBottomCustom.vue?vue&type=template&id=0fc0d2ef&"
import script from "./TheBottomCustom.vue?vue&type=script&lang=js&"
export * from "./TheBottomCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports